<!--

 -->

<template>
  <div class="gsl-hrm-recruitment-interviewer-input">
    <employee-autocomplete
      :label="!showDelete ? $t('recruitment.interviewer') : null"
      :disabled="disabled"
      v-bind="$attrs"
      api-path="/api/v2/recruitment/interviewers"
    />
    <oxd-icon-button
      v-if="showDelete && !disabled"
      name="trash-fill"
      class="gsl-hrm-recruitment-delete-icon"
      :with-container="false"
      @click="remove"
    />
  </div>
</template>

<script>
import EmployeeAutocomplete from '@/core/components/inputs/EmployeeAutocomplete.vue';

export default {
  name: 'InterviewerAutocomplete',
  components: {
    'employee-autocomplete': EmployeeAutocomplete,
  },
  inheritAttrs: false,
  props: {
    showDelete: {
      type: Boolean,
      required: true,
    },
    includeEmployee: {
      type: String,
      default: 'currentAndPast',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['remove'],
  methods: {
    remove() {
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-recruitment {
  &-interviewer-input {
    display: flex;
    align-items: flex-start;
    ::v-deep(.oxd-input-group__label-wrapper:empty) {
      display: none;
    }
  }
  &-delete-icon {
    margin-left: 1rem;
    margin-top: 1rem;
  }
}
</style>
